<template>
  <div class="container">



    <div class="row">
      <div class="col">
        <h2 id="hydrology">5. Hydrology</h2>
        <p>
          The GRDC Major River Basins dataset contains <strong>{{ factsheet.data.mountain_hydro.basins_overlap.length }} overlapping
          major river basins</strong> , with the <strong>{{ factsheet.data.mountain_hydro.basins_overlap[0].name }}</strong> having the 
          most overlap by area (<strong>{{ factsheet.data.mountain_hydro.basins_overlap[0].intersect_percent | percent }}</strong>), 
          followed by 

          <span v-for="basin in factsheet.data.mountain_hydro.basins_overlap.slice(1,100)">
            <strong>{{ basin.name }}</strong> ({{ basin.intersect_percent | percent }})
            <template v-if="(basin.row + 1) == factsheet.data.mountain_hydro.basins_overlap.length">
              , and 
            </template>
            <template v-if="(basin.row) == factsheet.data.mountain_hydro.basins_overlap.length">
              rivers.
            </template>
            <template v-if="(basin.row +1) < factsheet.data.mountain_hydro.basins_overlap.length">
              ,
            </template>
          </span>

          The remaining <strong>{{ basinRemainder | percent }}</strong> is not covered by any <strong>major rivers</strong> in the GRCD major river basins dataset.
        </p>
        <p>
          There are a total of <strong>{{ factsheet.data.mountain_hydro.num_dams}}</strong> dams and reservoirs in the Global Dams and Reservoirs (GRanD) database. They are mainly used for <span v-html="damsMainUse" />. The locations of these dams are marked in the map with a blue square.
        </p>
      </div>

    </div>
    <div class="row">
      <div class="col col-10 offset-1">
        <ImageMap 
          title="Main River Basins" 
          v-bind:images="[{title:'test',source:'/mountain_hydro/Hydrology.png'}]" 
          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          attribution="Data: GRDC Major River Basins, FAO Major Rivers">
            
        </ImageMap>
      </div>
    </div>
    <div class="row">
      <div class="col col-10 offset-1">
        <table class="table table-sm">
          <caption>Table X. Main River Basins</caption>
          <tr>
            <th>River Name</th>
            <th>Destination</th>
            <th>Overlapping Area</th>
          </tr>
          <tr v-for="basin in factsheet.data.mountain_hydro.basins_overlap">
            <td>{{basin.name}}</td>
            <td>{{basin.sea}}</td>
            <td>{{basin.intersect_area | km2 }} ({{basin.intersect_percent | percent}})</td>
          </tr>
        </table>
      </div>
    </div>
    

  </div>
</template>

<script>
    /* eslint-disable */
    import ImageMap from '@/components/factsheet/maps/ImageMap.vue'

    import _ from 'lodash';

    export default {
        name: 'Hydrology and Water Resources',
        components: { ImageMap },
        props: ['location', 'factsheet', 'loaded'],
        data() {
            return {
            }
        },
        created() {
        },
        computed: {
          basinRemainder() {
            var remainderPerc = 100.0;
            for(var i=0; i<this.factsheet.data.mountain_hydro.basins_overlap.length;i++) {
              remainderPerc -= this.factsheet.data.mountain_hydro.basins_overlap[i].intersect_percent;
            }
            return remainderPerc;

            //return this.factsheet.data.mountain_cryo.total_area
            //return this.andList(this.factsheet.data.mountain_summary.basemap_data.populated_places.slice(0,4), "name")
          },
          damsMainUse() {
            function fmt(value) {
              if (value["main_use"] != null) {
                return "<strong>"+value["main_use"].toLowerCase()+ " ("+value["num_dams"]+")</strong>" 
              } else {
                return "<strong>undefined uses ("+value["num_dams"]+")</strong>" 
              }
            }
            return this.andListFmt(this.factsheet.data.mountain_hydro.dams_by_usage, fmt)
          }
        },
        mounted() {
        },
        filters: {
          percent: function (value) {
            return value.toFixed(1)+'%'
          },
          km2: function(value) {
            return parseInt(value/1000000)+" km²"
          },
        },
        methods: {
          urlFor(asset) {
            return process.env.VUE_APP_API+'/api/data/factsheet/'+this.factsheet.info.identifier+'/data/'+asset;
          },
          andList(list, attr, attrpercent) {
            var ret = ""
            for(var i=0; i<list.length;i++) {
              var percent = attrpercent ? ' ('+list[i][attrpercent]+'%)' : ''
              if (list.length == 1) {
                return list[i][attr]+percent
              }
              if(i == list.length-1) {
                ret += " and "+list[i][attr]+percent
              } else {
                ret += list[i][attr]+percent+", "
              }
            }
            return ret
          },
          andListFmt(list, formatter) {
            var ret = ""
            for(var i=0; i<list.length;i++) {
              //var percent = attrpercent ? ' ('+list[i][attrpercent]+'%)' : ''
              if (list.length == 1) {
                return formatter(list[i])
              }
              if(i == list.length-1) {
                ret += " and "+formatter(list[i])
              } else {
                ret += formatter(list[i])+", "
              }
            }
            return ret
          }
        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
</style>

<style scoped>

caption {
  caption-side: top;
  font-weight:bold;
  font-size:1em;
  padding:5px;
  color:rgb(33, 37, 41);
  padding-left:0px;
}
table {
   font-size:0.75em;
}
table th, table td {
  padding-left:0px;
}

</style>